export default "__VITE_ASSET__CsW06Ztd__"